var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tabs-wrapper d-flex"},_vm._l((_vm.tabItems),function(tabItem,tabItemIndex){return _c('b-button',{key:tabItemIndex,staticClass:"tab-link",class:{
        active:
          _vm.$route.query.section === tabItem.name,
      },on:{"click":function($event){return _vm.changeUrlParam(tabItem.name)}}},[_vm._v(" "+_vm._s(tabItem.label)+" ")])}),1),_vm._t("tab-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }